import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../../_shared/shared.module';
import { AdminPaymentHandlerComponent } from './admin-payment-handler/admin-payment-handler.component';
import { PaymentListFiltersComponent } from './payment-list/payment-list-filters/payment-list-filters.component';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { PaymentRoutingModule } from './payment-routing.module';

@NgModule({
  imports: [
    SharedModule,
    MatTabsModule,
    MatMenuModule,
    PaymentRoutingModule,
  ],
  declarations: [
    PaymentListComponent,
    PaymentListFiltersComponent,
    AdminPaymentHandlerComponent
  ],
})
export class PaymentModule {
}
